import React, { useEffect, useState } from "react";
import { MDBDataTable } from "mdbreact";
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button, Input, FormGroup, Label, Form } from "reactstrap";
import { useNavigate } from 'react-router-dom';
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { httpGet, httpPost, httpPUT } from "../../../common/petitions";
import reportes from './model.json';
import "../tables.scss";
import "../Puestos.scss";

export const ReporteMOI = () => {
  const [data, setData] = useState(null);
  const [totals, setTotals] = useState(null);
  const [puestos, setPuestos] = useState({});
  
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const rowsData = await httpGet('/moi/reportes', navigate);
        setPuestos(rowsData);
        console.log(rowsData);
        const jsonData = { "columns": reportes.ccu, "rows": rowsData.resume };
        setData(jsonData);
        setTotals(rowsData.totals);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [navigate]);

 

  const options = {
    rowClassName: (row) => (row.rowIndex === 0 ? 'style="position: sticky; top: 0; background-color: #f2f2f2;"' : ''),
  };

  document.title = "Mano de obra Directa - Reportes puestos - IPG";

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Mano de obra directa" title="Reportes generales" />
          <Row>
            
            <Col className="col-12">
              <Card>
                <CardBody>
                  <h1>
                    Presupuesto: {totals}
                  </h1>
                  <h3>
                    Desgloce por CCU
                  </h3>
                  {data && <MDBDataTable responsive striped bordered data={data} options={options} />}
                  {/* <h3>
                    Desgloce por semana
                  </h3> */}
                  
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};
